import React from 'react';
import { motion } from 'framer-motion';
import { scrollToCheckout } from '../utils/scrollToCheckout';
interface CTAButtonProps {
  text?: string;
  className?: string;
  size?: 'normal' | 'large';
}
export function CTAButton({
  text = 'SÍ, QUIERO EL KIT AHORA',
  className = '',
  size = 'normal'
}: CTAButtonProps) {
  return <motion.button onClick={scrollToCheckout} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`
        bg-emerald-600 hover:bg-emerald-500 text-white font-display font-bold rounded-xl shadow-lg shadow-emerald-600/20 transition-colors
        ${size === 'large' ? 'py-5 px-8 text-xl md:text-2xl w-full max-w-md' : 'py-4 px-8 text-lg w-full max-w-sm'}
        ${className}
      `} data-id="element-58">
      {text}
    </motion.button>;
}